import * as React from "react";
import { hydrateRoot } from 'react-dom/client';
import ReactQueryClientProvider from "@contexts/QueryClientContext";
import { ErrorBoundary } from "react-error-boundary";
import HttpError from "@helper/httpError";
import { constructFullUrl } from "@helper/urlHelpers";

// Do not forget to add the component to build/crtitical/components-defaults.js and also to vite.config.js

const onError = (error: Error) => {
    if (error instanceof HttpError) {
        if(error.status === 401) {
            document.location.href = "/login/";
        }
        // user's token is no longer valid, redirecting to login to authorise
        if(error.status === 401) {
            window.location.href = constructFullUrl('/logout/');
        }
    }
}

function ErrorRender() {
    return <div>Something went wrong, please <a href="#" onClick={() => document.location.reload()}>try again</a>.</div>
}

function hydrateComponents() {
    window['SSR_COMPONENT_LIST'].forEach(({ domID, name, data }) => {
        const Component = React.lazy(() => import(`../../components/${name}.tsx`))
        if (typeof Component === 'object' || typeof Component === 'function') {
            const element = document.getElementById(domID) as Element

            if (element) {
                const isDevelopment = process.env.NODE_ENV === 'development';
                const AppContent = (
                    <ErrorBoundary onError={onError} fallbackRender={ErrorRender}>
                        <ReactQueryClientProvider>
                            <Component {...(data as Record<string, unknown>)} />
                        </ReactQueryClientProvider>
                    </ErrorBoundary>
                );
                
                hydrateRoot(
                    element,
                    isDevelopment ? (
                        <React.StrictMode>
                            {AppContent}
                        </React.StrictMode>
                    ) : AppContent
                );
            }
            else {
                console.error(`${domID} element is not present on the page`)
            }
        } else {
            console.error(`${name} is not valid element`)
        }
    })
}
if (import.meta.env.SSR) {
    hydrateComponents()
} else {
    if (document.readyState === "complete" || document.readyState === "interactive") {
        hydrateComponents()
    } else {
        document.addEventListener('DOMContentLoaded', hydrateComponents)
    }
}

window.reHydrateComponents = hydrateComponents;
